import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { TabContext } from '../TabContext';

const TabContent = ({ children }) => {
    const { tabIndex } = useContext(TabContext);

    return React.Children.toArray(children)
        .filter((e) => e)
        .map((child, idx) => (
            <div
                key={`tab${idx}-panel`}
                id={`tab${idx}-panel`}
                aria-labelledby={`tab${idx}`}
                className={`${idx !== tabIndex ? 'hidden' : ''} tabs__panel`}
            >
                {child}
            </div>
        ));
};

TabContent.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.bool, PropTypes.element])),
    ]),
};

export default TabContent;
